import { isSupportedTimeZone } from "@learn-flow/contracts";

export type TimeZoneOption = {
  value: string;
  label: string;
  region: string;
};

let cachedOptions: TimeZoneOption[] | null = null;

export function timeZoneOptions(): TimeZoneOption[] {
  if (cachedOptions) return cachedOptions;
  const values = [
    "UTC",
    ...(typeof Intl.supportedValuesOf === "function" ? Intl.supportedValuesOf("timeZone") : []),
  ];
  cachedOptions = [...new Set(values)].map((value) => ({
    value,
    region: value.includes("/") ? (value.split("/")[0] ?? "Other") : "Universal",
    label: timeZoneLabel(value),
  }));
  return cachedOptions;
}

export function browserTimeZoneSuggestion(): string | null {
  const value = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return value && isSupportedTimeZone(value) ? value : null;
}

export function timeZoneLabel(value: string): string {
  const location =
    value === "UTC" ? "Universal time" : value.split("/").slice(1).join(" / ").replaceAll("_", " ");
  let offset = "";
  try {
    offset =
      new Intl.DateTimeFormat("en-US", {
        timeZone: value,
        timeZoneName: "shortOffset",
      })
        .formatToParts(new Date())
        .find((part) => part.type === "timeZoneName")?.value ?? "";
  } catch {
    // Only already-validated values are normally passed here.
  }
  return `${location || value}${offset ? ` · ${offset}` : ""} — ${value}`;
}
